<h5 class="p-16 m-0 bottomBorderStyle">{{ title }}</h5>
<div class="pb-8 pl-16">
  <div class="pt-8 m-0 pb-10 section-title">
    SELECTED FILE(S)@if (count) {
    <span style="margin-left: 16px"></span>
  }
  @if (count) {
    <span class="count-icon font-s">{{ count }}</span>
  }
</div>
<p class="m-0 pb-10 secondary-text font-medium">
  Tags can only be applied to files
</p>
</div>
<mat-divider></mat-divider>
<div class="p-16 input-min-spacing mt-20">
  <app-dynamic-controls
    [bucketType]="currentBreadcrumbItem.BucketType"
    [expanded]="true"
    [isMultipleTags]="true"
    (controlValues)="selectedTags($event)"
    (cancelOperation)="cancel($event)"
    >
  </app-dynamic-controls>
</div>
